"use strict";

angular.module("vendor")
.service("SalesRepresentativeService", function($resource, appConfig, FlashBag) {
    var queryResource = $resource(appConfig.API_SERVER + "/sales-representatives/:id/", {
        id: "@id"
    }, {
        get: {
            method: "GET"
        }
    });
    var userQueryResource = $resource(appConfig.API_SERVER + "/sales-representatives/:id/user/", {
        id: "@id"
    }, {
        post: {
            method: "POST",
            interceptor: {responseError: FlashBag.responseErrorInterceptor}
        },
        update: {
            method: "PUT",
            interceptor: {responseError: FlashBag.responseErrorInterceptor}
        },
    });

    this.get = function(params) {
        return queryResource.get(params);
    };

    this.disconnectUserAndUpdatePassword = function(userVendorId, password) {
        return userQueryResource.post({id: userVendorId, password: password}).$promise;
    };

    this.updateUserPassword = function(userVendorId, password) {
        return userQueryResource.update({id: userVendorId, password: password}).$promise;
    };
});



//////////////////
// WEBPACK FOOTER
// ./vendor/sections/sale-representative/sale-representative.service.js
// module id = 884
// module chunks = 0